import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";

 export class VendorCreditContractBus extends BaseBus
 {
     constructor(busObj: VendorCreditContractBus = null) {
         super(busObj);
     }

     CID(): any {
         return this.vendorCreditItemId;
     }
     refNo: string;
     vendorCreditItemId: any;
     quantity: number;
     cost: number;
     orderNumber: string;
     dispatchNumber: string;
     supplierName: string;
     invDesc: string;
     invNumber: string;
     locationName: string;
     orderId: any;
     get totalCost(): number {
         return this.cost * this.quantity;
     }
     set totalCost(value: number) {

     }
 }
